import { Reveal } from "@components/ui";

/* ─── Icons ─── */

function CardIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f24d2b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
      <rect x="5" y="14" width="5" height="2" rx="0.5" fill="#f24d2b" stroke="none" />
    </svg>
  );
}

function RepeatIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f24d2b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="17 1 21 5 17 9" />
      <path d="M3 11V9a4 4 0 014-4h14" />
      <polyline points="7 23 3 19 7 15" />
      <path d="M21 13v2a4 4 0 01-4 4H3" />
    </svg>
  );
}

function BankIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f24d2b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" />
    </svg>
  );
}

/* ─── Data ─── */

const methods = [
  {
    title: "Online Payment Portal",
    description: "Pay securely using Visa, Mastercard, or Apple Pay through our portal",
    icon: <CardIcon />,
  },
  {
    title: "Auto-Pay Setup",
    description: "Enable recurring billing for hassle-free automatic payments each month",
    icon: <RepeatIcon />,
  },
  {
    title: "Bank Transfer",
    description: "Direct bank transfer details available in your customer portal",
    icon: <BankIcon />,
  },
];

/* ─── Component ─── */

export function PaymentMethodsSection() {
  return (
    <section className="w-full bg-[#f6f6f9] py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#f24d2b]/10 text-[#f24d2b] text-[13px] font-semibold tracking-[-0.02em] uppercase">
              Payment Options
            </span>
            <h2 className="text-center text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] leading-[1.1]">
              Multiple Ways to Pay
            </h2>
            <p className="text-center text-[14px] md:text-[16px] lg:text-[20px] tracking-[-0.04em] text-[#62636c] max-w-[700px]">
              Multiple ways to pay your bill quickly and securely
            </p>
          </div>
        </Reveal>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {methods.map((method, index) => (
            <Reveal key={method.title} direction="up" delay={index * 100}>
              <div className="group h-full rounded-[16px] md:rounded-[24px] bg-white border border-transparent p-6 md:p-8 flex flex-col gap-5 hover:border-[#e8e9ed] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300">
                {/* Icon */}
                <div className="w-12 h-12 rounded-[12px] bg-[#fef0ec] flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
                  {method.icon}
                </div>

                {/* Title */}
                <h3 className="text-[18px] md:text-[22px] lg:text-[24px] tracking-[-0.04em] font-medium text-[#1c1c1c] font-albert-sans leading-[1.2]">
                  {method.title}
                </h3>

                {/* Description */}
                <p className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] text-[rgba(10,14,46,0.75)] font-albert-sans leading-[1.5]">
                  {method.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
